import { trackPageview } from './analytics/trackPageview';
import { eventHandler } from './eventHandler';
import { eventSiteHandler } from './eventSiteHandler';
import { teaserHandler } from './teaserHandler';
import { IAnalyticsMessage } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let latestPage: any;

type TAnalyticsMessageHandlerParams = {
  message: IAnalyticsMessage;
  isDotPin?: boolean;
};

export function analyticsMessageHandler({ message, isDotPin }: TAnalyticsMessageHandlerParams) {
  const [eventType, eventParams] = message.value;

  switch (eventType) {
    case 'eventSite':
      message.value[1].page = isNewbuildingPrizeBannerEvent(eventParams)
        ? mergePageWithExtra(latestPage, eventParams.page)
        : latestPage;
      eventSiteHandler(message.value);
      break;

    case 'pageview':
    case 'pageviewSite':
      eventParams.isIframe = true;

      if (eventParams.page) {
        eventParams.page.extra = {
          ...eventParams.page.extra,
          is_dot_pin: isDotPin,
        };
      }

      latestPage = eventParams.page || null;
      trackPageview(eventParams);
      break;

    case 'teaser':
      message.value[1].page = {
        ...latestPage,
        extra: {
          ...latestPage?.extra,
          ...eventParams.page?.extra,
        },
      };
      teaserHandler(message.value);
      break;

    case 'event':
    case 'eventEbc':
    case 'eventEnrich':
      message.value[1].page = latestPage;
      eventHandler(message.value);
      break;
  }
}

function isNewbuildingPrizeBannerEvent(eventParams: Record<string, unknown>) {
  return (
    eventParams.category === 'trap' &&
    eventParams.label === 'purchase_giveaway_banner' &&
    ['show_sopr', 'click_sopr'].includes(String(eventParams.action))
  );
}

type TAnalyticsPage =
  | {
      extra?: Record<string, unknown>;
      [key: string]: unknown;
    }
  | null
  | undefined;

function mergePageWithExtra(latestPageData: TAnalyticsPage, pageData: TAnalyticsPage) {
  if (!latestPageData && !pageData) {
    return undefined;
  }

  return {
    ...latestPageData,
    ...pageData,
    extra: {
      ...latestPageData?.extra,
      ...pageData?.extra,
    },
  };
}
